/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_TitleInputs */

const en_share_title = /** @type {(inputs: Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share a link`)
};

const de_share_title = /** @type {(inputs: Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link teilen`)
};

/**
* | output |
* | --- |
* | "Share a link" |
*
* @param {Share_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_title = /** @type {((inputs?: Share_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_title(inputs)
	return en_share_title(inputs)
});